import styled from 'styled-components'

const Title = styled.h2`
    margin: 0;
    font-size: 26px;
    line-height: 34px;
    font-weight: bold;

    text-align: center;
`

Title.displayName = 'Title'

export default Title